module.exports = __webpack_public_path__ + "static/media/fondo_sub_categoria.f74d7310.png";